module.exports = __webpack_public_path__ + "static/media/valor3.6d8319c6.png";